import { createRouter, createWebHistory } from "vue-router";
import { buildRoutes, evaluateString, getLocalRoutes } from "@/services/routeSetup";
import store from '@/store';
const router = (async () => {
    const builtRoutes = await buildRoutes();
    const router = createRouter({
        history: createWebHistory(process.env.BASE_URL),
        routes: builtRoutes
    });
    store.dispatch("setRouter", router);
    getLocalRoutes(router);
    router.beforeEach(async (to, from, next) => {
        if (!(await store.getters.isLoggedIn) && !(to.name == "login" || to.name == "secret")) {
            router.push({ name: "login", query: { ...to.query, ...{ returnUrl: to.path } } });
            next();
            return;
        }
        if (store.getters.user.NoSiteAccess && to.name !== "noaccess") {
            router.push({ name: "noaccess" });
            next();
            return;
        }
        if (to.path == "/")
            router.push({ name: "boyden" });
        const suffix = "";
        if (to.meta && to.meta.title) {
            const title = evaluateString(to.meta.title, to);
            document.title = title + suffix;
        }
        else {
            document.title = "Boyden";
        }
        if (to.path.startsWith("/admin") && !store.getters.isAdmin) {
            router.push({ name: "login" });
        }
        else {
            next();
        }
    });
    return router;
})();
export default router;
